import styled from '@emotion/styled';

import {Field} from '@britishcouncil/react-solas-ors3';

export const Title = styled.p`
  font-size: 20px;
`;
export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RequiredFieldContainer = styled.div`
    label::after {
        color: red;
        content: "*";
        margin-left: 2px;
    }
`